<template>
    <div style="height: 500px" v-resize="setItemsPerPage" ref="viewer">
<!--        <v-btn @click="loadScreenshots">Click</v-btn>-->

        <v-scroll-x-transition hide-on-leave>
            <div class="d-flex align-center justify-center fill-height" v-if="loading" style="height: 252px">
                <app-centre-loader label="Fetching Screenshots"></app-centre-loader>
            </div>
        </v-scroll-x-transition>

        <v-scroll-x-transition hide-on-leave>
            <div v-if="!loading">
                <div class="d-flex align-center justify-space-between pb-2 px-2">

                    <v-btn
                            class="mx-2"
                            color="primary"
                            text
                            @click="viewMore = true"
                    >
                        <v-icon left>mdi-fullscreen</v-icon>
                        View More
                    </v-btn>

                    <div class="flex-grow-1">

                    </div>

                    <div class="px-2">
                        <v-text-field
                                v-model="searchStr"
                                clearable
                                outlined
                                dense
                                hide-details
                                prepend-inner-icon="mdi-magnify"
                                placeholder="Search"
                        ></v-text-field>
                    </div>
                </div>

                <div class="px-4 d-flex align-center">
                    <v-btn
                            fab
                            :disabled="page === 1"
                            class="mr-4"
                            small
                            color="primary"
                            @click="formerPage"
                    >
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>

                    <v-data-iterator
                            :items="screenshots"
                            :page.sync="page"
                            :items-per-page.sync="itemsPerPage"
                            :search="searchStr"
                            class="flex-grow-1"
                            hide-default-footer
                    >
                        <template v-slot:default="props">

                            <div class="d-flex align-center justify-space-around">
                                <div
                                        v-for="item in props.items"
                                        :key="item._id"
                                        class="px-4"
                                        style="max-width: 300px"
                                >
                                    <app-screenshot-card @showScreenshot="initDlg(item)" :screenshot="item"></app-screenshot-card>
                                </div>
                            </div>

<!--                            <v-row>-->
<!--                                <v-col-->
<!--                                        v-for="item in props.items"-->
<!--                                        :key="item._id"-->
<!--                                        cols="12"-->
<!--                                        sm="6"-->
<!--                                        md="4"-->
<!--                                        lg="3"-->
<!--                                >-->
<!--                                    <app-screenshot-card @showScreenshot="initDlg(item)" :screenshot="item"></app-screenshot-card>-->
<!--                                </v-col>-->
<!--                            </v-row>-->
                        </template>
                    </v-data-iterator>

                    <v-btn
                            fab
                            :disabled="page === numberOfPages"
                            class="ml-4"
                            small
                            color="primary"
                            @click="nextPage"
                    >
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </div>

            </div>
        </v-scroll-x-transition>

        <v-dialog
                v-if="showDlg"
                v-model="showDlg"
                width="90%"
        >
            <v-card class="d-flex flex-column of-y" style="width: 100%; height: 90vh">
                <v-card-title class="d-flex align-center pa-0 ma-0">
                    <div class="dlg-title-bar flex-grow-1">
                        Screenshot {{format(selectedShot.start, dateFormats.longDate)}}
                    </div>
                    <v-btn
                            icon
                            color="error"
                            @click="showDlg = !showDlg"
                            class="mx-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <div class="d-flex justify-start flex-wrap px-4">
                    <v-btn small text color="primary" @click.stop="showDlg = false; gotoAppStats(selectedShot.match)">
                        <app-icon :match="selectedShot.match" left small/>
                        {{ selectedShot.match }}
                    </v-btn>
                    <v-btn small text color="primary" @click.stop="showDlg = false; gotoTeam(selectedShot.teamId)">
                        <v-icon left small>mdi-account-group</v-icon>
                        {{ selectedShot.teamName }}
                    </v-btn>
                    <v-btn small text color="primary"
                           @click.stop="showDlg = false; gotoEmployee(selectedShot.employeeId)">
                        <v-icon left small>mdi-account</v-icon>
                        {{ selectedShot.employeeName }}
                    </v-btn>
                    <v-btn small text color="primary"
                           @click.stop="showDlg = false; gotoDeviceSettings(selectedShot.deviceId)">
                        <v-icon left small>mdi-cellphone-link</v-icon>
                        {{ selectedShot.deviceName }}
                    </v-btn>
                </div>
                <div v-if="dlgLoading" style="height: 200px;" class="flex-grow-1 d-flex align-center justify-center">
                    <app-centre-loader label="Loading Image"></app-centre-loader>
                </div>
                <div v-else-if="dlgImageError" style="height: 200px;" class="flex-grow-1 d-flex flex-column align-center justify-center overline error--text">
                    <div>
                        Error Loading Image
                    </div>
                    <div>
                        Please Try Again Later
                    </div>
                </div>
                <div v-else class="flex-grow-1 pt-4 pb-0" style="overflow-x: hidden; overflow-y: hidden;">
<!--                    <div style="overflow-x: auto; overflow-y: hidden; cursor: all-scroll" ref="imageBox">-->

<!--&lt;!&ndash;                        <img id="myimage" :src="dlgImage" style="max-height: 100%; margin: auto" alt="Screenshot">&ndash;&gt;-->

<!--                        Hello-->
                        <viewer
                                style="width: 100%"
                                :images="[dlgImage]"
                                :options="viewerOptions"
                        >
                            <img style="display: none" v-for="src in [dlgImage]" :src="src" :key="src">
                        </viewer>

<!--                    </div>-->
                </div>
            </v-card>
        </v-dialog>

        <app-screenshot-dlg
                v-if="viewMore"
                :shown.sync="viewMore"
                :screenshots="screenshots"
                @showScreenshot="initDlg($event)"
                @gotoDeviceSettings="viewMore = false; gotoDeviceSettings($event)"
                @gotoEmployee="viewMore = false; gotoEmployee($event)"
                @gotoTeam="viewMore = false; gotoTeam($event)"
                :initial-filter="searchStr"
        />


    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import AppScreenshotCard from "@/components/Shared/Screenshots/AppScreenshotCard";
import {dateFormats, isValidUrl} from "@/core/codeFunctions";
import {format} from "date-fns";
import axios from "axios";
import {Base64} from "js-base64";
import AppScreenshotDlg from "@/components/Shared/Screenshots/AppScreenshotDlg";
import AppIcon from "@/components/Shared/AppIcon";
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue'

Vue.use(VueViewer)

const filterStructure = {
    teamIds: [],
    employeeIds: [],
    deviceIds: [],
    matches: []
}

export default {
    components: {AppIcon, AppScreenshotDlg, AppScreenshotCard, AppCentreLoader},
    props: {
        filter: Object,
    },
    data() {
        return {
            zoomed: true,
            loading: false,
            screenshots: [],
            page: 1,
            itemsPerPage: 4,
            itemsPerPageArray: [4, 8, 12],
            searchStr: null,
            selectedShot: null,
            showDlg: false,
            format,
            dateFormats,
            dlgLoading: true,
            dlgImage: null,
            dlgImageError: false,
            viewMore: false,
            isValidUrl,
            viewerOptions: {
                "inline": true,
                "button": true,
                "navbar": false,
                "title": false,
                "toolbar": true,
                "tooltip": true,
                "movable": true,
                "zoomable": true,
                "rotatable": true,
                "scalable": false,
                "transition": false,
                "fullscreen": false,
                "keyboard": true,
            },
        }
    },

    watch: {
        devicesWithAccess() {
            this.loadScreenshots()
        }
    },

    mounted() {
        this.loadScreenshots();
        this.setItemsPerPage();
    },

    methods: {
        ...mapActions(['gotoAppStats', 'gotoTeam', 'gotoEmployee', 'gotoDeviceSettings',]),

        setItemsPerPage() {

            //1512

            const minWidthPerItem = 300
            const width = this.$refs.viewer.clientWidth - 112
            const items = Math.floor(width / minWidthPerItem)
            this.itemsPerPage = items
        },


        async initDlg(item) {
            this.selectedShot = item;
            this.showDlg = true;
            try {
                this.dlgLoading = true;
                this.dlgImage = null;
                this.dlgImageError = false;
                const fetchUrl = await this.$newReq('POST', 'screenshots/getPresignedScreenshotUrl', {imageId: this.selectedShot.imageId})
                const {data: imageBlob} = await axios.get(fetchUrl, {responseType: 'blob'})
                const blob = imageBlob.slice(0, imageBlob.size, "image/jpeg")
                const blobUrl = URL.createObjectURL(blob)
                this.dlgImage = blobUrl
                // setTimeout(() => {
                //     magnify("myimage", 3);
                // }, 500)

            } catch (e) {
                this.dlgImageError = true
                console.log(e)
            } finally {
                this.dlgLoading = false
            }
        },

        async loadScreenshots() {
            this.loading = true;
            try {
                this.screenshots = (await this.$newReq('POST', 'screenshots/getScreenshotsMeta', {
                    start: this.$store.state.ref.dashboard.selectedRange.start,
                    end: this.$store.state.ref.dashboard.selectedRange.end,
                    ...this.filter
                })).map((obj) => {
                    obj.start = new Date(obj.start)
                    obj.end = new Date(obj.end)
                    return obj
                })

            } catch (e) {
                console.log(e)
            } finally {
                this.loading = false
            }
        },
        nextPage () {
            if (this.page + 1 <= this.numberOfPages) this.page += 1
        },
        formerPage () {
            if (this.page - 1 >= 1) this.page -= 1
        },
    },
    computed: {
        ...mapGetters(['devicesWithAccess']),
        numberOfPages () {
            return Math.ceil(this.screenshots.length / this.itemsPerPage)
        },
    }

}
</script>

<style scoped>

* {box-sizing: border-box;}


</style>